import { atom } from 'nanostores'

import type { CountryCode } from '@/services/schemas'

const defaultCountry = (import.meta.env.VITE_DEFAULT_COUNTRY as CountryCode) || null

const $country = atom<CountryCode | null>(defaultCountry)

export {
  $country,
}
